export default __webpack_public_path__ + "static/media/team_2.201595ee.jpg";